import { IsEqual } from '../types';

export const isEqual: IsEqual = (x) => (y) => x === y;
